// COMENZILE DIN DOUĂ LITERE, în stilul Revit, și literele cu care încep ele.
//
// STAU ÎNTR-UN FIȘIER AL LOR fiindcă au DOI cititori care nu se pot vedea unul
// pe altul: `Masa`, care le execută, și `Panza2D`, care trebuie să știe ce
// litere sunt ale unei comenzi ca să nu panorameze cu ele (v. nota din `jos`).
// `Panza2D` nu poate importa `Masa` — `Masa` îl are pe `Panza` în ea, iar
// `Panza` îl are pe `Panza2D`, deci ar ieși un ciclu la rulare. Aici nu iese:
// de sus în jos se importă numai model și document, plus un tip din `Panza`,
// care se șterge la compilare.
import { adaugaAxul, stergeAlesele } from "./model";
import type { TronsonDoc } from "../doc";
import type { Ales } from "../Desen";
import type { Unealta } from "./Panza";

/** CE FACE FIECARE COD DE DOUĂ LITERE — lista de la birou, din Revit.
 *
 *  Numai codurile pentru care avem CHIAR comanda. Restul listei (stâlpi,
 *  grinzi, cote, etichete, ascunderi, punctele de prindere pe feluri) n-are
 *  corespondent în editor, iar o tastă care nu face nimic e mai rea decât una
 *  care lipsește: cine o apasă crede că a mers.
 */
type FaptaRevit = (c: {
  e: KeyboardEvent;
  setUnealta: (u: Unealta) => void;
  roteste: (grade: number) => void;
  oglindeste: (axa: "h" | "v") => void;
  ales: Ales;
  /** TOT ce e aprins. Un singur obiect ales e o listă de unu (v. `alege`), deci
   *  faptele de grup n-au nevoie de două drumuri. */
  alesele: readonly Ales[];
  potScrie: boolean;
  aplica: (f: (d: TronsonDoc) => TronsonDoc, opt?: { contur?: boolean }) => void;
  alege: (a: Ales) => void;
  reincadreaza: () => void;
  setStransa: (f: (v: boolean) => boolean) => void;
  dubleazaAles: () => void;
}) => void;

export const COMENZI_REVIT: Record<string, FaptaRevit> = {
  // 1. MODELARE
  WA: (c) => c.setUnealta("perete"),
  DR: (c) => c.setUnealta("usa"),
  WN: (c) => c.setUnealta("fereastra"),
  RM: (c) => c.setUnealta("camera"),
  CM: (c) => c.setUnealta("mobila"),
  GR: (c) => {
    // `Grid` = axa de trasare. La noi axa se pune PE un perete, deci cere unul
    // ales — ca butonul din bară, care stă stins fără el.
    if (c.ales?.fel === "perete" && c.potScrie) {
      c.aplica((d) => adaugaAxul(d, (c.ales as { i: number }).i));
    }
  },
  // 2. MODIFICARE
  CO: (c) => { if (c.ales && c.potScrie) c.dubleazaAles(); },
  RO: (c) => { if (c.ales) c.roteste(c.e.shiftKey ? -90 : 90); },
  MM: (c) => { if (c.ales && c.potScrie) c.oglindeste("h"); },
  DM: (c) => { if (c.ales && c.potScrie) c.oglindeste("v"); },
  DE: (c) => {
    // TOATĂ SELECȚIA, nu doar ultimul adunat: `ales` e cel din urmă apăsat, deci
    // dintr-o selecție de cinci pleca una singură (v. `stergeAlesele`).
    if (c.alesele.length && c.potScrie) {
      c.aplica((d) => stergeAlesele(d, c.alesele));
      c.alege(null);
    }
  },
  MD: (c) => { c.setUnealta("sageata"); c.alege(null); },
  // 4. VIZUALIZARE
  // `ZA` a ieșit: reîncadrarea e pe Z singur (v. ascultătorul de taste).
  PP: (c) => c.setStransa((v) => !v),
};

/** CÂT SE AȘTEAPĂ A DOUA LITERĂ. Stă aici, nu în `Masa`, fiindcă are doi
 *  cititori: `Masa` o folosește ca să POTRIVEASCĂ, iar `Panza2D` ca să știe că
 *  litera asta poate fi a unei comenzi și deci nu e a panoramării. */
export const RASTIMP_COMANDA_MS = 1500;

/** Primele litere ale codurilor: numai ele se țin în așteptare. */
export const INCEPUTURI = new Set(Object.keys(COMENZI_REVIT).map((k) => k[0]));
